import {IconButton, Menu, MenuItem} from '@material-ui/core';
import React from 'react';

import flagEs from './flags/espanhol.png';
import flagEn from './flags/ingles.png';
import flagPt from './flags/portugues.png';

import {getLocale} from '../../../../i18n/helper';
import './change-lenguage.css';

interface IPropsChangeLenguage {
  locales: string[];
}

const ChangeLenguage: React.FC<IPropsChangeLenguage> = ({locales}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const currentLang = getLocale();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getFlagByLang = (lang: string) => {
    switch (lang) {
      case 'en':
        return <img className="flag" src={flagEn} alt="Idioma Inglês" />;
      case 'es':
        return <img className="flag" src={flagEs} alt="Idioma Espanhol" />;
      case 'pt':
      default:
        return <img className="flag" src={flagPt} alt="Idioma Português" />;
    }
  };

  const changeLang = (lang: string) => {
    if (currentLang !== lang) {
      window.localStorage.setItem('SEI_POCKET_LOCALE', lang);
      location.reload();
    } else {
      setAnchorEl(null);
    }
  };

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {getFlagByLang(currentLang)}
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {locales.map(lang => (
          <MenuItem key={lang} onClick={() => changeLang(lang)}>
            {getFlagByLang(lang)}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
export default ChangeLenguage;



// WEBPACK FOOTER //
// ./src/features/election/components/ChangeLenguage/index.tsx